import React from 'react'
import { makeStyles, tokens } from '@fluentui/react-components'
import { SnippetSegment } from '../../../helpers/highlightHelper'

const useStyles = makeStyles({
   mark: {
      backgroundColor: tokens.colorPaletteYellowBackground2,
      color: tokens.colorNeutralForeground1,
      fontWeight: tokens.fontWeightSemibold,
      borderRadius: tokens.borderRadiusSmall,
      padding: '0 2px',
   },
})

type HighlightedTextProps = {
   segments: SnippetSegment[]
}

/**
 * Not built on RTFOutput: that renders with dangerouslySetInnerHTML, so marking a plain-text offset
 * there would land inside a tag.
 */
export const HighlightedText = ({ segments }: HighlightedTextProps): JSX.Element => {
   const classes = useStyles()

   return (
      <>
         {segments.map((segment, index) =>
            segment.match ? (
               <mark key={index} className={classes.mark}>
                  {segment.text}
               </mark>
            ) : (
               <React.Fragment key={index}>{segment.text}</React.Fragment>
            )
         )}
      </>
   )
}
